{
  "backgroundColor": "transparent",
  "tooltip": {
    "trigger": "item",
    "formatter": "{a} <br/>{b}: {c} ({d}%)"
  },
  "legend": {
    "top": "5%",
    "left": "center",
    "textStyle": {
      "color": "#939393",
      "fontSize": 14
    }
  },
  "series": [
    {
      "name": null,
      "type": "pie",
      "radius": ["40%", "70%"],
      "avoidLabelOverlap": false,
      "padAngle": 5,
      "itemStyle": {
        "borderRadius": 5
      },
      "label": {
        "show": false,
        "position": "center"
      },
      "emphasis": {
        "label": {
          "show": true,
          "fontSize": 20,
          "fontWeight": "normal"
        }
      },
      "labelLine": {
        "show": true
      },
      "data": []
    }
  ]
}
